export default "__VITE_PUBLIC_ASSET__6750bd13__"